module.exports = __webpack_public_path__ + "img/us-map-2.31a53202.svg";